if (document.getElementById("lq-splash")) {
  document.getElementById("lq-splash").classList?.add("hidden");
  document.body.classList?.remove("overflow-hidden");
  // set cookie lq-splash to true for 5 minutes
  const cookieDate = new Date(new Date().getTime() + 5*60*1000);
  document.cookie = "lq-splash=true;expires=" + cookieDate.toUTCString() + ";path=/";
}
